export default __webpack_public_path__ + "static/media/v-41.3193b7ef.svg";